// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"do","header":"dp","title":"dq","subHeader":"dr"};